import { CALL_API } from '../middleware/ApiMiddleware';

export const FETCH_EVENT_LIST_REQUEST = 'FETCH_EVENT_LIST_REQUEST';
export const FETCH_EVENT_LIST_SUCCESS = 'FETCH_EVENT_LIST_SUCCESS';
export const FETCH_EVENT_LIST_FAILURE = 'FETCH_EVENT_LIST_FAILURE';

const baseURL = 'admin/system-events';

export const fetchEventList = () => ({
  [CALL_API]: {
    endpoint: `${baseURL}`,
    method: 'get',
    authenticated: true,
    types: [FETCH_EVENT_LIST_REQUEST, FETCH_EVENT_LIST_SUCCESS, FETCH_EVENT_LIST_FAILURE],
  },
});
